exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".FxFilter-type,\n.FxFilter input {\n  display: none; }\n\n.FxFilter-slider {\n  width: 100%;\n  height: 160px; }\n  .FxFilter-slider .SliderControl-bar {\n    background-color: #0068e9; }\n  .FxFilter-slider.is-zero .SliderControl-bar {\n    border-color: #666b72; }\n\n.FxFilter-frequency {\n  margin-top: 0.5em;\n  color: #0b1c31;\n  font-size: 0.75rem;\n  text-align: center; }\n\n.FxFilter-gain {\n  font-size: 0.875rem;\n  font-weight: bold;\n  text-align: center; }\n\n.FxFilter-label {\n  font-size: 0.875rem;\n  font-weight: bold;\n  text-align: center; }\n", ""]);

// exports
